<div
  [style.backgroundColor]="hexCode"
  [class.marker]="!square && !circle"
  [class.square]="square"
  [class.circle]="circle"
></div>
